import { Injectable, EventEmitter } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { StartupConfiguration } from '../models/startupConfiguration.model';
import { Language } from '../models/language.model';
import { BehaviorSubject } from 'rxjs';
import { ThreeDService } from './three-d.service';
import { ConfigurationReceived } from '../models/configurationReceived.model';
import { filter, take } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { AppInsightsService } from './appinsights.service';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  private _startupInput: StartupConfiguration;
  private _languageReceived$: EventEmitter<Language> = new EventEmitter<Language>();

  get languageReceived$(): EventEmitter<Language> {
    return this._languageReceived$;
  }

  configurationReceived$: EventEmitter<ConfigurationReceived> = new EventEmitter<ConfigurationReceived>();
  moveToSummaryForLoadedConfiguration$: EventEmitter<null> = new EventEmitter<null>();
  loading$: EventEmitter<boolean> = new EventEmitter<boolean>();
  initialized$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  sharedLinkConfiguration$: BehaviorSubject<false | string> = new BehaviorSubject<false | string>(false);
  priceEnabledSetting$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private appInsightsService: AppInsightsService,
    private activatedRoute: ActivatedRoute,
    private threeDService: ThreeDService
  ) {
    this._startupInput = new StartupConfiguration();
  }

  get startupInput(): StartupConfiguration {
    return this._startupInput;
  }

  readInput(queryParams: ParamMap) {
    if (queryParams.has('share')) {
      this.appInsightsService.logEvent('Opening shared link', { configurationId: queryParams.get('share') });
      this.setUpSharedLink(queryParams.get('share'));
      return;
    }
    queryParams.keys.forEach(key => {
      switch (key.toLowerCase()) {
        case 'configurationid':
          this._startupInput.configurationId = queryParams.get(key);
          if (this._startupInput.configurationId) {
            this.configurationReceived$.emit({ configurationId: this._startupInput.configurationId, makeCopy: false });
          }
          break;
        case 'itemid':
          this._startupInput.itemId = queryParams.get(key);
          break;
        case 'language':
          this._startupInput.language = new Language(queryParams.get(key));
          this.languageReceived$.emit(this._startupInput.language);
          break;
        case 'token':
          this._startupInput.token = queryParams.get(key);
          break;
      }
    });
    this.threeDService.finishedBuilding$.subscribe(() => {
      this.languageReceived$.emit(this._startupInput.language);
    });
    if (this._startupInput.token) {
      this.priceEnabledSetting$.next(true);
      this.initialized$.next(true);
    } else {
      this.priceEnabledSetting$.next(false);
      this.initialized$.next(true);
    }
  }
  setUpSharedLink(shareId: string) {
    this.sharedLinkConfiguration$.next(shareId);
  }

  loadConfiguration(configurationId: string) {
    const language = this.activatedRoute.snapshot.queryParamMap.get('language');
    this.threeDService.finishedBuilding$.pipe(take(1)).subscribe(() => this.loading$.emit(true));
    this.threeDService.modelFinishedConstructing$
      .pipe(filter(x => x == ConfigurationService.COOLING_CELL_TIMER_LOAD_CONFIGURATION))
      .subscribe(() => this.moveToSummaryForLoadedConfiguration$.emit(null));
    this.configurationReceived$.emit({ configurationId, makeCopy: true, languageOverride: language });
  }

  get token() {
    return this._startupInput.token;
  }
}
